export default __webpack_public_path__ + "static/media/brakes-selected.e699ccc5.svg";